import React from "react";
import styles from "./IoPointsList.module.scss";
import AddButton from "../../../../components/AddButton/AddButton";
import { connect } from "react-redux";
import { Loader } from "semantic-ui-react";
import { hasWriteAccess } from "../../../../utils/utils";

type StateProps = {
  ioConfig: State.IoConfig;
};
type Props = {
  standardPoints: Api.StandardPoint[];
  // eslint-disable-next-line @typescript-eslint/ban-types
  onActionClick: Function;
  // eslint-disable-next-line @typescript-eslint/ban-types
  onPointClick: Function;
  selectedActionId: string | undefined;
  // eslint-disable-next-line @typescript-eslint/ban-types
  onAddNewPointClick: Function;
  // eslint-disable-next-line @typescript-eslint/ban-types
  onPointEditClick: Function;
  loading: boolean;
  scrollToPointId?: string;
  activeUser: Api.User | undefined;
};
const IoPointsList = (props: Props & StateProps) => {
  const {
    onActionClick,
    selectedActionId,
    onAddNewPointClick,
    standardPoints,
    onPointEditClick,
    loading,
    scrollToPointId,
    activeUser
  } = props;

  const ioPointsAndActions = [];

  const [ioBoardsHeight, setIoBoardsHeight] = React.useState(0);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const refs = standardPoints.reduce((acc: any, value) => {
    acc[value.id] = React.createRef();
    return acc;
  }, {});
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const scrollToPoint = (id: any) => {
    if (!refs[id].current) {
      return;
    }

    refs[id].current.scrollIntoView({
      behavior: "smooth",
      block: "end"
    });
  };
  React.useEffect(() => {
        setIoBoardsHeight(window.innerHeight - 220);
      }, [props]);

  React.useEffect(() => {
    if (props.scrollToPointId) {
      scrollToPoint(scrollToPointId);
    }
  }, [props.scrollToPointId]);

  if (standardPoints?.length > 0) {
    // StandardPoints can be inputs or outputs and we want to group them together first and then sort by index
    const buildPoints = () => {
      const points = standardPoints
        .sort((a, b) => {
          if (a.isInput === b.isInput) {
            return a.ioindex - b.ioindex;
          } else {
            return b.isInput ? 1 : -1;
          }
        })
        .map(point => {
          const actions = point.standardActions?.map((action: Api.StandardAction) => (
            <p
              key={action.id}
              onClick={() => onActionClick(action.id, point.id)}
              className={action.id === selectedActionId ? styles.SelectedAction : ""}
            >
              {action.eventClassEnumNavigation?.enumName + " [" + action.eventClassEnumNavigation?.enumValue + "]"} <br />{" "}
              {action.eventTypeEnumNavigation?.enumName + " [" + action.eventTypeEnumNavigation?.enumValue + "]"}{" "}
            </p>
          ));
          return (
            <div key={point.id}>
              <li
                ref={refs[point.id]}
                className={
                  point.id === props.ioConfig.selectedStandardBoard.standardPointId
                    ? styles.PointListItem + " " + styles.SelectedPoint
                    : styles.PointListItem
                }
              >
                <div className={styles.IOSymbolDiv}>
                  <div className={point.isInput ? styles.InputSymbol : styles.OutputSymbol} />
                </div>
                <span className={styles.IoPointTitle}>
                  {point.ioindex} - {point.ioname}
                </span>
                <button className="basic" onClick={() => onPointEditClick(point)}>
                  Edit
                </button>
              </li>
              <li>
                <div className={styles.IoActions}>{actions}</div>
              </li>
            </div>
          );
        });
      return points;
    };

    ioPointsAndActions.push(buildPoints());
  } else {
    ioPointsAndActions.push("No IO Points");
  }

  return (
    <div className={styles.IoPointsList}>
      <div className={styles.Header}>
        <span>I/O Points</span>
        {hasWriteAccess(activeUser, "Lift") ? (
          <AddButton title="Add point" onClick={() => onAddNewPointClick()} id="addPointButton" />
        ) : (
          <AddButton title="Add point" onClick={() => onAddNewPointClick()} id="disablebutton" />
        )}
      </div>
      <div style={{ height: ioBoardsHeight && ioBoardsHeight + "px", overflowY: "scroll" }}>
      <ul className={styles.IoPoints}>
        {loading ? (
          <div key="onlyChild" className={styles.LoaderWrapper}>
            <Loader inline="centered" content="Loading points" active={true} />
          </div>
        ) : (
          ioPointsAndActions
        )}
      </ul>
      </div>
    </div>
  );
};

const mapStateToProps = (state: State.Root) => ({
  ioConfig: state.ioConfig
});
export default connect(mapStateToProps)(IoPointsList);
